import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../icons/Icon';
import styles from './AiStudioButton.module.scss';

declare global {
    interface Window {
        __aiStudio: any;
    }
}

export const AiStudioButton = ({ onClick }: AiStudioButtonProps) => {

    const { t } = useTranslation();

    return (
        <div className={styles.aiContainer} onClick={onClick}>

            <button className={styles.aiButton}>
                <span>
                    <Icon type="ai-wand" size="small" />
                    {t("ai_studio.open")}
                </span>
            </button>
        </div>
    );
};

export type AiStudioButtonProps = {
    onClick?: () => void;
};